"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LogoCircleText = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

/**
 * The JOBMATCH.ME Circle Logo with comany name as text
 *
 * @param {width}         size  Logo width
 * @param {height}        size  Logo height
 * @param {background}    color Background color
 * @param {primary}       color Primary color
 * @param {secondary}     color Secondary color
 *
 **/
var LogoCircleText = function LogoCircleText(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 'auto' : _ref$height,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? '#004324' : _ref$background,
      _ref$primary = _ref.primary,
      primary = _ref$primary === void 0 ? '#004324' : _ref$primary,
      _ref$secondary = _ref.secondary,
      secondary = _ref$secondary === void 0 ? '#ffed00' : _ref$secondary;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "logoJMM",
    width: width,
    height: height,
    viewBox: "0 0 930.088 336.26",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(16081.476 578.833)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        className: "a",
        transform: "translate(-15713.371 -437.885)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(0 0.208)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: primary,
            d: "M20.32,1.2H35.43V34.129c0,7.086-1.98,12.4-5.94,16.048S20.008,55.6,13.026,55.6a20.223,20.223,0,0,1-7.294-1.459A14.166,14.166,0,0,1,0,50.594L6.565,38.61a7.116,7.116,0,0,0,6.148,3.126,7.4,7.4,0,0,0,5.419-1.98,7.15,7.15,0,0,0,2.188-5.627V1.2Z",
            transform: "translate(0 0.05)"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: primary,
            d: "M46.849,8.128A28.972,28.972,0,0,1,67.482,0,28.555,28.555,0,0,1,88.011,8.128a26.055,26.055,0,0,1,8.545,19.695,26.055,26.055,0,0,1-8.545,19.695,28.972,28.972,0,0,1-20.633,8.128,28.972,28.972,0,0,1-20.633-8.128A26.055,26.055,0,0,1,38.2,27.823,26.7,26.7,0,0,1,46.849,8.128ZM57.582,37.723a13.964,13.964,0,0,0,23.863-9.9,14,14,0,0,0-23.863-9.9,13.528,13.528,0,0,0-4.064,9.9A13.362,13.362,0,0,0,57.582,37.723Z",
            transform: "translate(1.607 0)"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: primary,
            d: "M136.38,25.9c3.126.729,5.419,2.188,6.773,4.585a14.957,14.957,0,0,1,2.188,8.024,15.185,15.185,0,0,1-4.9,11.567c-3.23,3.022-7.711,4.481-13.338,4.481H99.7V1.2h22.821c6.252,0,11.15,1.25,14.8,3.647a11.568,11.568,0,0,1,5.419,10.316,13.117,13.117,0,0,1-1.771,6.773A9.348,9.348,0,0,1,136.38,25.9ZM114.914,12.663V21.52h6.357c4.272,0,6.357-1.459,6.357-4.481,0-2.918-2.084-4.481-6.357-4.481h-6.357Zm7.607,30.324c5.106,0,7.607-1.667,7.607-5.106,0-3.335-2.5-5.106-7.607-5.106h-7.607V42.882h7.607Z",
            transform: "translate(4.193 0.05)"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(153.287 0)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: background,
            d: "M207.748,1.2l5.21,53.249H197.953l-2.709-27.927-8.858,27.927H173.777l-8.858-27.823-2.605,27.823H147.1L152.206,1.2H167.42l12.713,31.679L192.847,1.2h14.9Z",
            transform: "translate(-147.1 0.259)"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: background,
            d: "M248.468,1.2l20.945,53.249h-14.38l-3.439-8.858H230.961l-3.439,8.858H212.1L234.087,1.2h14.38ZM235.546,34.129h11.671l-5.835-15.214Z",
            transform: "translate(-144.366 0.259)"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: background,
            d: "M263.3,1.2h43.037V15.164H292.378V54.449H277.164V15.164H263.2V1.2Z",
            transform: "translate(-142.217 0.259)"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: background,
            d: "M336.124,41.8a15.338,15.338,0,0,0,12.088-5.419L353.943,49.3a25.363,25.363,0,0,1-8.441,4.689,30.782,30.782,0,0,1-30.949-6.565A25.892,25.892,0,0,1,305.8,27.727q0-11.411,8.753-19.695A30.125,30.125,0,0,1,335.707-.2a29.774,29.774,0,0,1,9.8,1.667,25.363,25.363,0,0,1,8.441,4.689l-5.731,13.026a16.2,16.2,0,0,0-22.821-1.355,13.158,13.158,0,0,0-4.481,9.9,12.8,12.8,0,0,0,4.481,9.9A15.117,15.117,0,0,0,336.124,41.8Z",
            transform: "translate(-140.425 0.2)"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: background,
            d: "M390.429,1.2h15.214V54.449H390.429V34.754H372.714V54.345H357.5V1.2h15.214V20.791h17.715Z",
            transform: "translate(-138.25 0.259)"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(429.121 37.097)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: secondary,
            d: "M428.16,51.76a9.289,9.289,0,0,1-6.773,2.814,9.124,9.124,0,0,1-6.774-2.814,9.289,9.289,0,0,1-2.813-6.773,9.123,9.123,0,0,1,2.813-6.773,9.29,9.29,0,0,1,6.774-2.814,9.123,9.123,0,0,1,6.773,2.814,9.289,9.289,0,0,1,2.814,6.773A9.123,9.123,0,0,1,428.16,51.76Z",
            transform: "translate(-411.8 -35.4)"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(454.234 1.459)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: primary,
            d: "M496.548,1.2l5.21,53.249H486.752l-2.709-27.927-8.857,27.927H462.577l-8.858-27.823-2.605,27.823H435.9L441.006,1.2H456.22l12.713,31.679L481.646,1.2h14.9Z",
            transform: "translate(-435.9 -1.2)"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: primary,
            d: "M540.73,15.164H520.41V21.52h16.464V34.233H520.41V40.59h20.32V54.554H505.3V1.2h35.43Z",
            transform: "translate(-432.981 -1.2)"
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "matrix(0.951, -0.309, 0.309, 0.951, -16081.476, -496.498)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(0 0)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: background,
            width: "266.441",
            height: "266.993",
            rx: "133.22",
            transform: "translate(0 0)"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fill: primary,
          d: "M22.552,79.952H0V0H12.741L43.7,38.169,74.28,0H86.834V79.952H64.394V47.03l-16.637,19.8H39.452l-16.9-19.8Z",
          transform: "translate(67.143 92.234)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fill: primary,
          d: "M0,79.778V0H63.594V19.69H22.275v10.9H56.862V49.322H22.275V60.485h41.32V79.778Z",
          transform: "translate(166.446 92.408)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
          fill: secondary,
          cx: "12.822",
          cy: "12.822",
          r: "12.822",
          transform: "translate(29.307 144.269)"
        })]
      })]
    })
  });
};

exports.LogoCircleText = LogoCircleText;

var _default = /*#__PURE__*/_react.default.memo(LogoCircleText);

exports.default = _default;